import { PlatformLogo } from "@/components/PlatformLogo";
import { useTranslation } from "@/core/i18n";
import { Button } from "atoms/button/Button";
import { TextButton } from "atoms/text-button/TextButton";
import { PersonalisationHeading } from "modules/personalisation/components/PersonalisationHeading";
import { PersonalisationScreenLayout } from "modules/personalisation/components/PersonalisationScreenLayout";

interface PersonalisationIntroProps {
  platformLogoUrl?: string;
  onBegin?: () => void;
  onSkip?: () => void;
}

export const PersonalisationIntro = ({
  platformLogoUrl,
  onBegin,
  onSkip,
}: PersonalisationIntroProps) => {
  const { t } = useTranslation();
  return (
    <PersonalisationScreenLayout
      footer={
        <>
          <Button style="primary" size="large" fullWidth onClick={onBegin}>
            {t("personalisationIntro.begin")}
          </Button>
          <TextButton variant="secondary" onClick={onSkip}>
            {t("personalisationIntro.skipForNow")}
          </TextButton>
        </>
      }
      contentClassName="pt-20"
    >
      <PlatformLogo logoUrl={platformLogoUrl} className="mb-[20%] self-center" />

      <PersonalisationHeading customSize="30px">
        {t("personalisationIntro.heading")}
      </PersonalisationHeading>

      <p className="mb-16 text-body1 text-secondary">{t("personalisationIntro.subtitle")}</p>

      <p className="text-body2 text-dark-grey">{t("personalisationIntro.getStartedCaption")}</p>
    </PersonalisationScreenLayout>
  );
};
